export const CONDITION_OPTIONS = [
	{ label: 'All Changes', value: -1 },
	{ label: '\u00b1 5%', value: 5 },
	{ label: '\u00b1 10%', value: 10 },
	{ label: '\u00b1 15%', value: 15 },
	{ label: '\u00b1 20%', value: 20 },
	{ label: '> 20%', value: 21 }
]

export const STOCK_STATUS_OPTIONS = [
	{ label: 'Stock', value: 'stock' },
	{ label: 'Out of Stock', value: 'out-of-stock' },
	{ label: 'Deslisted', value: 'deslisted' },
	{ label: 'New Listed', value: 'new-listed' },
]

export const AMAZON_RELEASE_STATUS_OPTIONS = [
	{ label: 'Action needed in Amazon Catalog', value: 'Action needed in Amazon Catalog' },
	{ label: 'Stock needed at Amazon', value: 'Stock needed at Amazon' },
]

export const EMBARGO_STATUS_OPTIONS = [
	{ label: 'Met', value: 'Met' },
	{ label: 'Needs Action', value: 'Needs Action' },
	{ label: 'Not Met', value: 'Not Met' },
]

export const INCLUDE_NEW_PRODUCTS_OPTIONS = [
	{ label: 'Include all products', value: 'No' },
	{ label: 'Include only New products', value: 'Yes' }
]

export const FREQUENCY_OPTIONS = [
    { label: 'Daily', value: 'date' },
    { label: 'Weekly (Mondays)', value: 'week' },
]

export const REPORT_TYPES = {
	PRICE_CHANGES: 'priceChange',
	STOCK_CHANGES: 'stockChange',
	STOCK_DETAILS: 'stockDetails',
	MARKET_ANALYZER: 'marketAnalyzer',
	PP_DETAILS: 'productPageDetail',
	DIGITAL_SHELF: 'digitalShelf',
	SELLER_DEEP_DIVE: 'sellerDeepDive',
	FLASH_OFFERS: 'flashOffer',
	PP_KPI: 'productPageKpi',
	EMBARGO_DATE: 'embargoDate',
	AMAZON_RELEASE_DATE: 'amazonReleaseDate',
	LOST_BUY_BOX_DETAILS: 'lostBuyBoxDetails'
}

export const OPTIONS_STREET_DATE = [
	{ label: 'In the past', value: 'past' },
	{ label: 'In the future', value: 'future' },
]

export const PRICES_PERCENTAGES_UNDER_REFERENCE = [
	{ label: 'All ', value: -1 },
	{ label: '- 1%', value: 1 },
	{ label: '- 3%', value: 3 },
	{ label: '- 5%', value: 5 },
]